import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import { useCallback } from 'react';
import en from '../../../../lang/en-us';
import { SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import SuccessScreen from '../SuccessScreen';
const { dashboard } = en;

export default function ChangeDividendSuccess(props: any) {
    const { reqId, data = [], dividend } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);

    const getList = useCallback(() => {
        return data.map((ele: SCHEMES_RESPONSE) => ({
            text: `${ele.amcName} - ${ele.schemeName}`,
        }));
    }, [data.length]);

    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.ChangeDividend.Success.back}
                backLink="nct"
                info1={dashboard.ChangeDividend.Success.subHeadingInfo1}
                infospan1={dividend}
                info2={dashboard.ChangeDividend.Success.subHeadingInfo2}
                infospan2={reqId}
                info3={dashboard.ChangeDividend.Success.subHeadingInfo3}
                handleClick={() => props.history.push('/portal/track')}
                list={getList()}
            />
        </div>
    );
}
